 //  $(document).ready(function() {
 //  $('.slider-for').slick({
 //   slidesToShow: 1,
 //   slidesToScroll: 1,
 //   arrows: false,
 //   fade: true,
 //   asNavFor: '.slider-nav'
 // });
 // $('.slider-nav').slick({
 //   slidesToShow: 3,
 //   slidesToScroll: 1,
 //   asNavFor: '.slider-for',
 //   dots: true,
 //   focusOnSelect: true
 // });

 // $('a[data-slide]').click(function(e) {
 //   e.preventDefault();
 //   var slideno = $(this).data('slide');
 //   $('.slider-nav').slick('slickGoTo', slideno - 1);
 // });
 //  });

$(document).ready(function() {
    let autoCycle;
    let currentTabIndex = 0;
    const tabs = $('.tabs-nav li');
    const tabCount = tabs.length;
    let cycleCount = 0;
    const maxCycles = 5; // Number of times the tabs should cycle

    function activateTab(index) {
        const currentTab = $(tabs[index]).find('a').attr('href');

        // Fade out the currently active tab
        $('.tab.active').css('opacity', 0).removeClass('active');

        // Set timeout to ensure the tab is completely hidden before changing
        setTimeout(function() {
            $('.tab').hide();
            $(currentTab).show().css('opacity', 1).addClass('active');
            
            // Fade in the new tab
            $(currentTab).animate({ opacity: 1 }, 500);
        }, 200);

        tabs.removeClass('active');
        $(tabs[index]).addClass('active');
    }

    function startAutoCycle() {
        autoCycle = setInterval(function() {
            currentTabIndex = (currentTabIndex + 1) % tabCount;
            activateTab(currentTabIndex);

            // Increment cycle count every time we return to the first tab
            if (currentTabIndex === 0) {
                cycleCount++;
            }

            // Stop cycling after reaching maxCycles
            if (cycleCount >= maxCycles) {
                stopAutoCycle();
            }
        }, 3000); // Change tab every 3 seconds
    }

    function stopAutoCycle() {
        clearInterval(autoCycle);
    }

    // Start automatic cycling
    startAutoCycle();

    // Handle tab clicks
    $('.tabs-nav a').on('click', function(e) {
        e.preventDefault();
        stopAutoCycle();

        const index = $(this).parent().index();
        activateTab(index);
    });

    // Activate the first tab by default
    activateTab(currentTabIndex);
});